// Reopens Shopify's cookie banner so a visitor can change or withdraw consent.
// Guarded: does nothing (and throws nothing) when the privacy API is not loaded.
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-frb-cookie-prefs]');
  if (!trigger) return;
  event.preventDefault();
  try {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && typeof api.showPreferences === 'function') {
      api.showPreferences();
    } else if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  } catch (error) {
    // the banner is not available on this page; nothing to open
  }
});
